// Play de grabación de llamada compartido por los paneles del CRM (timeline del
// lead y tab global de Llamadas). Pide la URL firmada on-demand y reproduce con
// <audio>. La URL es de corta vida (expiresAt); la pedimos al pulsar, y si la
// que devuelve el CRM ya viene casi caducada la re-pedimos antes de reproducir.
//
// Extraído de LeadTimeline (Fase 3) para reutilizarlo en Llamadas (Fase 5) sin
// clonar el manejo de expiresAt + onError.

import { useState } from "react";
import { CrmHttpError, describeCrmError } from "../../api/crm";
import { getRecordingUrl } from "../../api/crmTimeline";

// Margen para considerar una URL firmada como "ya expirada": si le queda menos
// de esto, la re-pedimos antes de reproducir (evita reproducir una URL que
// caduca a mitad de la carga).
const EXPIRY_MARGIN_MS = 10_000;

export default function RecordingPlayer({ callId }: { callId: string }) {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const load = async () => {
    if (loading) return;
    setLoading(true);
    setErr(null);
    try {
      let res = await getRecordingUrl(callId);
      const exp = Date.parse(res.expiresAt);
      // Si la URL viene expirada (o a <10s de caducar), la re-pedimos antes de
      // reproducir para no cargar una URL que muere a mitad.
      if (Number.isFinite(exp) && exp - Date.now() < EXPIRY_MARGIN_MS) {
        res = await getRecordingUrl(callId);
      }
      setUrl(res.url);
    } catch (e) {
      setErr(
        e instanceof CrmHttpError
          ? describeCrmError(e)
          : "No se pudo obtener la grabación",
      );
    } finally {
      setLoading(false);
    }
  };

  if (url) {
    // eslint-disable-next-line jsx-a11y/media-has-caption
    return (
      <audio
        controls
        src={url}
        style={{ width: "100%", height: 32, marginTop: "0.4rem" }}
        onError={() => {
          // La URL firmada expiró o falló: volvemos al botón para reintentar.
          setUrl(null);
          setErr("La grabación expiró, vuelve a intentarlo");
        }}
      />
    );
  }

  return (
    <div style={{ marginTop: "0.4rem" }}>
      <button type="button" onClick={load} disabled={loading} style={playBtn}>
        {loading ? "Cargando…" : "▶ Reproducir grabación"}
      </button>
      {err && (
        <div style={{ fontSize: ".72rem", color: "#b32424" }}>{err}</div>
      )}
    </div>
  );
}

const playBtn: React.CSSProperties = {
  padding: "0.25rem 0.55rem",
  borderRadius: "0.4rem",
  background: "white",
  color: "#0069d9",
  border: "1px solid #dee2e6",
  fontSize: ".74rem",
  fontWeight: 600,
  cursor: "pointer",
};
